import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { allpayments } from '../../../models/allpayments'; // Importing allpayments model
import { devConfig, countries, gamesCasino } from '../../../config/config'; // Importing configuration settings

/**
 * Class representing a table view for managing popups.
 * @extends JetView
 */
export default class tableView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        return {
            rows: [
                {
                    id: 'preloader', // ID for the preloader
                    cols: [
                        {
                            view: 'datatable', // DataTable view for displaying data
                            id: 'datatable', // ID for the datatable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            scrollY: true, // Enable vertical scrolling
                            columns: [
                                {
                                    id: 'rating', // Column ID
                                    header: '', // Column header
                                    width: 50, // Column width
                                    height: 25, // Column height
                                    template: function (obj) {
                                        // Template function for rendering cell content
                                        if (devConfig.getPermAction('popupEdit', 'Edit')) {
                                            return "<span class='webix_icon wxi-close edit'></span>"; // Edit icon if permission granted
                                        } else {
                                            return ''; // No icon if permission denied
                                        }
                                    },
                                },
                                {
                                    id: 'Id', // Column ID
                                    header: 'Id', // Column header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'GlobalId', // Column ID
                                    header: 'Global Id', // Column header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Title', // Column ID
                                    header: _('Título'), // Localized column header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Content', // Column ID
                                    header: _('Contenido'), // Localized column header
                                    width: 300, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'IsGame', // Column ID
                                    header: _('¿Es un juego?'), // Localized column header
                                    editor: 'combo', // Editor type
                                    options: [
                                        // Options for the combo editor
                                        { id: '1', value: _('Si') }, // Yes option
                                        { id: '0', value: _('No') }, // No option
                                    ],
                                    width: 70, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Redirection', // Column ID
                                    header: _('URL Redirección'), // Localized column header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Frame', // Column ID
                                    header: _('URL Frame'), // Localized column header
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Product', // Column ID
                                    header: _('Juego'), // Localized column header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'ClientId', // Column ID
                                    header: _('Usuarios Id'), // Localized column header
                                    width: 250, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'CountrySelect', // Column ID
                                    header: _('País'), // Localized column header
                                    hidden: !devConfig.getPermAction('filterByCountry', 'Add'), // Hide if permission denied
                                    css: 'prm-filterByCountry', // CSS class for styling
                                    width: 300, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'DateSend', // Column ID
                                    header: _('Fecha envío'), // Localized column header
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'DateExpiration', // Column ID
                                    header: _('Fecha expiración'), // Localized column header
                                    width: 300, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'State', // Column ID
                                    header: _('Estado'), // Localized column header
                                    editor: 'combo', // Editor type
                                    options: [
                                        // Options for the combo editor
                                        { id: 'A', value: _('Activo') }, // Active option
                                        { id: 'I', value: _('Inactivo') }, // Inactive option
                                    ],
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'State', // Column ID
                                    header: _('Leido'), // Localized column header
                                    editor: 'combo', // Editor type
                                    options: [
                                        // Options for the combo editor
                                        { id: '1', value: _('Si') }, // Yes option
                                        { id: '0', value: _('No') }, // No option
                                    ],
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                            ],
                            onClick: {
                                // Event handler for click events
                                edit: function (euv, id) {
                                    // Edit button click event
                                    $$('EditPopup').show(); // Show edit popup
                                },
                            },
                            math: true, // Enable math operations
                            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
                            pager: 'pagerA', // Pager ID
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        const _ = this.app.getService('locale')._; // Localization service
        grid = $$('datatable'); // Reference to the datatable
        var url = devConfig.geturlApi() + 'Client/GetClientSendPopup'; // API URL for fetching data
        var filter = ''; // Filter string for data fetching
        var createdLocalDate = // Local date string for date fields
            webix.Date.add(new Date(), -0, 'day').getFullYear() +
            ':' +
            ('00' + (webix.Date.add(new Date(), -0, 'day').getMonth() + 1)).slice(-2) +
            ':' +
            ('00' + webix.Date.add(new Date(), -0, 'day').getDate()).slice(-2) +
            ' ' +
            ('00' + webix.Date.add(new Date(), -0, 'day').getHours()).slice(-2) +
            ':' +
            ('00' + webix.Date.add(new Date(), -0, 'day').getMinutes()).slice(-2) +
            ':' +
            ('00' + webix.Date.add(new Date(), -0, 'day').getSeconds()).slice(-2);
        var popupSendPopup = webix.ui({
            // Popup for sending a new popup
            view: 'window', // Window view
            id: 'SendPopup', // ID for the send popup
            width: screen.width < 500 ? 350 : 650, // Responsive width
            height: screen.width < 500 ? 850 : 650, // Responsive height
            fullscreen: screen.width < 500 ? true : false, // Fullscreen mode for small screens
            head: {
                // Header configuration
                view: 'toolbar', // Toolbar view
                cols: [
                    {
                        view: 'label', // Label for the popup title
                        label: _('Enviar popup'), // Localized title
                        align: 'center', // Center alignment
                    },
                    {
                        view: 'icon', // Close icon
                        icon: 'wxi-close', // Icon type
                        click: function () {
                            // Click event to close the popup
                            this.getTopParentView().hide(); // Hide the popup
                        },
                    },
                ],
            },
            position: 'center', // Center position of the popup
            modal: true, // Modal popup
            body: {
                // Body configuration
                view: 'scrollview', // Scrollable view
                scroll: 'y', // Vertical scrolling
                body: {
                    view: 'form', // Form view
                    id: 'formSendPopup', // ID for the form
                    width: screen.width < 500 ? 350 : 650, // Responsive width
                    height: screen.width < 500 ? 850 : 600, // Responsive height
                    elements: [
                        // Form elements
                        {
                            view: 'text', // Text input for title
                            label: _('Título'), // Localized label
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Responsive label position
                            name: 'Title', // Input name
                            labelWidth: 150, // Label width
                            required: true, // Required field
                        },
                        {
                            view: 'textarea', // Textarea for content
                            label: _('Contenido'), // Localized label
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Responsive label position
                            name: 'Content', // Input name
                            labelWidth: 150, // Label width
                            required: true, // Required field
                        },
                        {
                            view: 'checkbox', // Checkbox for IsGame
                            label: _('¿Es un juego?'), // Localized label
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Responsive label position
                            name: 'IsGame', // Input name
                            id: 'IsGame', // ID for the checkbox
                            labelWidth: 200, // Label width
                        },
                        {
                            view: 'text', // Text input for redirection URL
                            label: _('URL Redirección'), // Localized label
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Responsive label position
                            name: 'Redirection', // Input name
                            labelWidth: 150, // Label width
                            required: true, // Required field
                            id: 'RedirectionURL', // ID for the input
                        },
                        {
                            view: 'text', // Text input for frame URL
                            label: _('URL Frame'), // Localized label
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Responsive label position
                            name: 'Frame', // Input name
                            labelWidth: 150, // Label width
                            required: false, // Not required
                            id: 'FrameURL', // ID for the input
                        },
                        {
                            view: 'combo', // Combo box for selecting a game
                            label: _('Juego'), // Localized label
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Responsive label position
                            name: 'Product', // Input name
                            id: 'ProductId', // ID for the combo
                            options: {
                                // Options for the combo
                                body: {
                                    dataFeed: function (text) {
                                        // Data feed function for dynamic loading
                                        var vthis = this; // Reference to the combo
                                        if (text.length > 2) {
                                            // Load data if input length is greater than 2
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json', // Set content type
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'es/Select/GamesCasinoSelect', // API URL for fetching games
                                                    '{"Filter":"' + text + '"}', // Request body
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message(
                                                                'Error! ', // Error message
                                                            );
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var resp = JSON.parse(
                                                                text, // Parse response
                                                            );
                                                            if (
                                                                !resp.HasError // Check for errors
                                                            ) {
                                                                vthis.parse(
                                                                    resp.Data, // Parse data into the combo
                                                                );
                                                            }
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            },
                            required: true, // Required field
                            labelWidth: 150, // Label width
                        },
                        {
                            view: 'textarea', // Textarea for user IDs
                            label: _('Usuarios Id'), // Localized label
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Responsive label position
                            name: 'ClientId', // Input name
                            labelWidth: 150, // Label width
                            required: true, // Required field
                        },
                        {
                            view: 'richselect', // Rich select for country selection
                            name: 'CountrySelect', // Input name
                            label: "<span class='icon-language'></span>" + _('País'), // Localized label with icon
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Responsive label position
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            labelWidth: 150, // Label width
                            options: {
                                // Options for the rich select
                                body: {
                                    template: function (obj) {
                                        // Template for rendering options
                                        return (
                                            "<i class='flags " + obj.icon + "'></i>" + obj.value // Render flag icon and country name
                                        );
                                    },
                                    data: countries, // Data source for countries
                                },
                            },
                            required: true, // Required field
                        },
                        {
                            view: 'datepicker', // Datepicker for send date
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha envío'), // Localized label with icon
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Responsive label position
                            name: 'DateSend', // Input name
                            stringResult: true, // Return string result
                            labelWidth: 150, // Label width
                            format: '%d %M %Y %H:%i:%s', // Date format
                            required: true, // Required field
                            timepicker: true, // Enable timepicker
                            value: createdLocalDate, // Default value
                        },
                        {
                            view: 'datepicker', // Datepicker for expiration date
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha expiración'), // Localized label with icon
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Responsive label position
                            name: 'DateExpiration', // Input name
                            stringResult: true, // Return string result
                            labelWidth: 150, // Label width
                            format: '%d %M %Y %H:%i:%s', // Date format
                            required: true, // Required field
                            timepicker: true, // Enable timepicker
                            value: createdLocalDate, // Default value
                        },
                        {
                            cols: [
                                // Button row
                                {
                                    view: 'button', // Cancel button
                                    value: _('Cancelar'), // Localized label
                                    click: function () {
                                        // Click event to cancel
                                        this.getTopParentView().hide(); // Hide the popup
                                        $$('formSendPopup').setValues(
                                            $$('formSendPopup').getCleanValues(), // Reset form values
                                        );
                                    },
                                },
                                {
                                    view: 'button', // Send button
                                    type: 'form', // Button type
                                    value: _('Enviar'), // Localized label
                                    click: function ($e) {
                                        // Click event to send
                                        var values = $$('formSendPopup').getValues(); // Get form values
                                        if ($$('formSendPopup').validate()) {
                                            // Validate form
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json', // Set content type
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/SendPopup', // API URL for sending popup
                                                    '{"Title":"' +
                                                        values.Title +
                                                        '",  "Content":"' +
                                                        values.Content +
                                                        '", "IsGame":"' +
                                                        values.IsGame +
                                                        '", "Redirection":"' +
                                                        values.Redirection +
                                                        '", "Frame":"' +
                                                        values.Frame +
                                                        '", "Product":"' +
                                                        values.Product +
                                                        '", "ClientId":"' +
                                                        values.ClientId +
                                                        '", "CountrySelect":"' +
                                                        values.CountrySelect +
                                                        '", "DateSend":"' +
                                                        values.DateSend +
                                                        '", "DateExpiration":"' +
                                                        values.DateExpiration +
                                                        '"}', // Request body
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message(
                                                                'Error! ', // Error message
                                                            );
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            data = JSON.parse(
                                                                text, // Parse response
                                                            );
                                                            if (data.HasError) {
                                                                // Check for errors
                                                                webix.message({
                                                                    text: _(
                                                                        'Error, comuniquese con soporte. ', // Error message
                                                                    ),
                                                                    type: 'error', // Error type
                                                                });
                                                            } else {
                                                                webix.message(
                                                                    _(
                                                                        'Popup enviado satisfactoriamente', // Success message
                                                                    ),
                                                                );
                                                            }
                                                        },
                                                    },
                                                );
                                            $$('formSendPopup').setValues(
                                                $$('formSendPopup').getCleanValues(), // Reset form values
                                            );
                                            this.getTopParentView().hide(); // Hide the popup
                                        } else {
                                            webix.message({
                                                title: '¡Error!', // Error title
                                                type: 'alert-error', // Error type
                                                text: _(
                                                    'Completa los campos...', // Error message
                                                ),
                                            });
                                        }
                                    },
                                },
                            ],
                        },
                    ],
                    elementsConfig: {
                        // Configuration for form elements
                        on: {
                            onChange: function () {
                                // Change event for validation
                                this.validate(); // Validate the form
                            },
                        },
                    },
                },
            },
        });
        var popupEditPopup = webix.ui({
            // Popup for editing an existing popup
            view: 'window', // Window view
            id: 'EditPopup', // ID for the edit popup
            width: screen.width < 500 ? 350 : 650, // Responsive width
            height: screen.width < 500 ? 950 : 750, // Responsive height
            fullscreen: screen.width < 500 ? true : false, // Fullscreen mode for small screens
            head: {
                // Header configuration
                view: 'toolbar', // Toolbar view
                cols: [
                    {
                        view: 'label', // Label for the popup title
                        label: _('Editar popup'), // Localized title
                        align: 'center', // Center alignment
                    },
                    {
                        view: 'icon', // Close icon
                        icon: 'wxi-close', // Icon type
                        click: function () {
                            // Click event to close the popup
                            this.getTopParentView().hide(); // Hide the popup
                        },
                    },
                ],
            },
            position: 'center', // Center position of the popup
            modal: true, // Modal popup
            body: {
                // Body configuration
                view: 'scrollview', // Scrollable view
                scroll: 'y', // Vertical scrolling
                body: {
                    view: 'form', // Form view
                    id: 'formEditPopup', // ID for the form
                    width: screen.width < 500 ? 350 : 650, // Responsive width
                    height: screen.width < 500 ? 950 : 700, // Responsive height
                    elements: [
                        // Form elements
                        {
                            view: 'text', // Text input for ID
                            label: _('Id'), // Localized label
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Responsive label position
                            name: 'Id', // Input name
                            labelWidth: 150, // Label width
                            readonly: true, // Read-only field
                        },
                        {
                            view: 'text', // Text input for title
                            label: _('Título'), // Localized label
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Responsive label position
                            name: 'Title', // Input name
                            labelWidth: 150, // Label width
                        },
                        {
                            view: 'textarea', // Textarea for content
                            label: _('Contenido'), // Localized label
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Responsive label position
                            name: 'Content', // Input name
                            labelWidth: 150, // Label width
                        },
                        {
                            view: 'checkbox', // Checkbox for IsGame
                            label: _('¿Es un juego?'), // Localized label
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Responsive label position
                            labelWidth: 250, // Label width
                            name: 'IsGame', // Input name
                            id: 'IsGameEdit', // ID for the checkbox
                        },
                        {
                            view: 'text', // Text input for redirection URL
                            label: _('URL Redirección'), // Localized label
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Responsive label position
                            name: 'Redirection', // Input name
                            labelWidth: 150, // Label width
                            required: true, // Required field
                            id: 'RedirectionURLEdit', // ID for the input
                        },
                        {
                            view: 'text', // Text input for frame URL
                            label: _('URL Frame'), // Localized label
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Responsive label position
                            name: 'Frame', // Input name
                            labelWidth: 150, // Label width
                            id: 'FrameURLEdit', // ID for the input
                        },
                        {
                            view: 'combo', // Combo box for selecting a game
                            label: _('Juego'), // Localized label
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Responsive label position
                            name: 'Product', // Input name
                            id: 'ProductIdEdit', // ID for the combo
                            options: {
                                // Options for the combo
                                body: {
                                    dataFeed: function (text) {
                                        // Data feed function for dynamic loading
                                        var vthis = this; // Reference to the combo
                                        if (text.length > 2) {
                                            // Load data if input length is greater than 2
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json', // Set content type
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'es/Select/GamesCasinoSelect', // API URL for fetching games
                                                    '{"Filter":"' + text + '"}', // Request body
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message(
                                                                'Error! ', // Error message
                                                            );
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var resp = JSON.parse(
                                                                text, // Parse response
                                                            );
                                                            if (
                                                                !resp.HasError // Check for errors
                                                            ) {
                                                                vthis.parse(
                                                                    resp.Data, // Parse data into the combo
                                                                );
                                                            }
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            },
                            labelWidth: 150, // Label width
                        },
                        {
                            view: 'textarea', // Textarea for user IDs
                            label: _('Usuarios Id'), // Localized label
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Responsive label position
                            name: 'ClientId', // Input name
                            labelWidth: 150, // Label width
                        },
                        {
                            view: 'richselect', // Rich select for country selection
                            name: 'CountrySelectId', // Input name
                            label: "<span class='icon-language'></span>" + _('País'), // Localized label with icon
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Responsive label position
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            labelWidth: 150, // Label width
                            options: {
                                // Options for the rich select
                                body: {
                                    template: function (obj) {
                                        // Template for rendering options
                                        return (
                                            "<i class='flags " + obj.icon + "'></i>" + obj.value // Render flag icon and country name
                                        );
                                    },
                                    data: countries, // Data source for countries
                                },
                            },
                        },
                        {
                            view: 'datepicker', // Datepicker for send date
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha envío'), // Localized label with icon
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Responsive label position
                            name: 'DateSend', // Input name
                            stringResult: true, // Return string result
                            labelWidth: 150, // Label width
                            format: '%d %M %Y %H:%i:%s', // Date format
                            timepicker: true, // Enable timepicker
                            value: createdLocalDate, // Default value
                        },
                        {
                            view: 'datepicker', // Datepicker for expiration date
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha expiración'), // Localized label with icon
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Responsive label position
                            name: 'DateExpiration', // Input name
                            stringResult: true, // Return string result
                            labelWidth: 150, // Label width
                            format: '%d %M %Y %H:%i:%s', // Date format
                            timepicker: true, // Enable timepicker
                            value: createdLocalDate, // Default value
                        },
                        {
                            cols: [
                                // Button row
                                {
                                    view: 'button', // Cancel button
                                    value: _('Cancelar'), // Localized label
                                    click: function () {
                                        // Click event to cancel
                                        this.getTopParentView().hide(); // Hide the popup
                                        $$('formEditPopup').setValues(
                                            $$('formEditPopup').getCleanValues(), // Reset form values
                                        );
                                    },
                                },
                                {
                                    view: 'button', // Send button
                                    type: 'form', // Button type
                                    value: _('Enviar'), // Localized label
                                    click: function ($e) {
                                        // Click event to send
                                        var values = $$('formEditPopup').getValues(); // Get form values
                                        webix
                                            .ajax()
                                            .headers({
                                                'Content-type': 'application/json', // Set content type
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'Client/SendPopup', // API URL for sending popup
                                                '{"Id":"' +
                                                    values.Id +
                                                    '", "Title":"' +
                                                    values.Title +
                                                    '",  "Content":"' +
                                                    values.Content +
                                                    '", "IsGame":"' +
                                                    values.IsGame +
                                                    '", "Redirection":"' +
                                                    values.Redirection +
                                                    '", "Frame":"' +
                                                    values.Frame +
                                                    '", "Product":"' +
                                                    values.Product +
                                                    '", "ClientId":"' +
                                                    values.ClientId +
                                                    '", "CountrySelect":"' +
                                                    values.CountrySelectId +
                                                    '", "DateSend":"' +
                                                    values.DateSend +
                                                    '", "DateExpiration":"' +
                                                    values.DateExpiration +
                                                    '", "State":"' +
                                                    values.State +
                                                    '"}', // Request body
                                                {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        webix.message(
                                                            'Error! ', // Error message
                                                        );
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        data = JSON.parse(text); // Parse response
                                                        if (data.HasError) {
                                                            // Check for errors
                                                            webix.message({
                                                                text: _(
                                                                    'Error, comuniquese con soporte. ', // Error message
                                                                ),
                                                                type: 'error', // Error type
                                                            });
                                                        } else {
                                                            webix.message(
                                                                _(
                                                                    'Popup editado satisfactoriamente', // Success message
                                                                ),
                                                            );
                                                        }
                                                    },
                                                },
                                            );
                                        $$('formEditPopup').setValues(
                                            $$('formEditPopup').getCleanValues(), // Reset form values
                                        );
                                        this.getTopParentView().hide(); // Hide the popup
                                    },
                                },
                            ],
                        },
                    ],
                },
            },
        });
        $$('formEditPopup').bind($$('datatable')); // Bind the edit form to the datatable
        this.on(this.app, 'messages:filter', (filterData) => {
            // Event handler for filtering messages
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string
            for (var i = 0; i < object.length; i++) {
                // Iterate over filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object values
                    if (object[i][0] == 'Datepicker') {
                        // Handle datepicker filter
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date); // Log date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add start date to filter string
                        string1 = string1 + '&dateTo=' + date[1]; // Add end date to filter string
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to string
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate over object entries
                            if (object2[j][1] !== null) {
                                // Check for non-null values
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]); // Create date object
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2); // Format start date
                                    string1 = string1 + '&' + dateFrom; // Add start date to filter string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]); // Create date object
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2); // Format end date
                                        string1 = string1 + '&' + dateTo; // Add end date to filter string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear the datatable
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load data with filters
            filter = string1; // Update filter variable
        });
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            // Event handler for sorting
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });
        this.on(this.app, 'sendPopup:button', (filterData) => {
            // Event handler for showing send popup
            popupSendPopup.show(); // Show send popup
            $$('formSendPopup').clearValidation(); // Clear validation errors
        });
        $$('ProductId').hide(); // Hide product ID field
        $$('IsGame').attachEvent('onChange', function (newv, oldv) {
            // Event handler for IsGame checkbox change
            if ($$('IsGame').getValue() == '1') {
                // If IsGame is checked
                $$('FrameURL').hide(); // Hide frame URL field
                $$('RedirectionURL').hide(); // Hide redirection URL field
                $$('ProductId').show(); // Show product ID field
            } else {
                $$('FrameURL').show(); // Show frame URL field
                $$('RedirectionURL').show(); // Show redirection URL field
                $$('ProductId').hide(); // Hide product ID field
            }
        });
        $$('IsGameEdit').attachEvent('onChange', function (newv, oldv) {
            // Event handler for IsGameEdit checkbox change
            if ($$('IsGameEdit').getValue() == '1') {
                // If IsGameEdit is checked
                $$('FrameURLEdit').hide(); // Hide frame URL field
                $$('RedirectionURLEdit').hide(); // Hide redirection URL field
                $$('ProductIdEdit').show(); // Show product ID field
            } else {
                $$('FrameURLEdit').show(); // Show frame URL field
                $$('RedirectionURLEdit').show(); // Show redirection URL field
                $$('ProductIdEdit').hide(); // Hide product ID field
            }
        });
    }
}

// FILE DOCUMENTED
